import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TFilterSave } from 'scw-digital-boards-widgets';
import { IDashboardWithWidgets, TWidgetSavePayload } from '../../pages/dashboard-content/dashboard-content.interface';

export const dashboardContentActions = createActionGroup({
  events: {
    fetchDashboardContents: props<{ dashboardId: number }>(),
    fetchDashboardContentsCompleted: props<{ dashboardWithWidgets: IDashboardWithWidgets }>(),
    fetchError: props<{ exceptionSource: 'fetchDashboardContents' | 'reassignWidgets' }>(),
    reassignWidgets: props<{ dashboardId: number; payload: TWidgetSavePayload[] }>(),
    reassignWidgetsCompleted: emptyProps(),
    resetReassignWidgetsStatus: emptyProps(),
    updateDefaultFilters: props<{ defaultFilterCard: TFilterSave[] }>(),
    updateNote: props<{ widgetId: number; note: string }>(),
  },
  source: 'dashboardContent',
});
